import React from 'react';
import TermsConditionsNav from '../Components/TermsConditions/TermsConditionsNav';
import TermsConditionsContent from '../Components/TermsConditions/TermsConditionsContent';
import SEO from '../Components/SEO/SEO';
import Spacing from '../Components/Spacing/Spacing';
import { useLanguage } from '../contexts/LanguageContext';

const TermsConditionsPage = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <SEO
        title={t('terms.meta.title')}
        description={t('terms.meta.description')}
        image="/images/logo.svg"
      />
      <Spacing lg={120} md={80} />
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <TermsConditionsNav />
          </div>
          <div className="col-lg-9 col-md-8">
            <TermsConditionsContent />
          </div>
        </div>
      </div>
      <Spacing lg={120} md={80} />
    </>
  );
};

export default TermsConditionsPage;
